/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseWidgetCustomImageResponse,
  WidgetCustomImageSaveRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 이미지 조회(전체)
 */
export const getV8DashboardsWidgetsCustomImages = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseWidgetCustomImageResponse>(
    { url: `/api/v8/dashboards/widgets/custom-images`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DashboardsWidgetsCustomImagesQueryKey = () => {
  return ['api', 'v8', 'dashboards', 'widgets', 'custom-images'] as const;
};

export const getGetV8DashboardsWidgetsCustomImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImages>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImages>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsWidgetsCustomImagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImages>>> = ({
    signal,
  }) => getV8DashboardsWidgetsCustomImages(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImages>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsWidgetsCustomImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImages>>
>;
export type GetV8DashboardsWidgetsCustomImagesQueryError = ErrorType<unknown>;

/**
 * @summary 이미지 조회(전체)
 */

export function useGetV8DashboardsWidgetsCustomImages<
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImages>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImages>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsWidgetsCustomImagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 이미지 저장
 */
export const postV8DashboardsWidgetsCustomImages = (
  widgetCustomImageSaveRequest: MaybeRef<WidgetCustomImageSaveRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  widgetCustomImageSaveRequest = unref(widgetCustomImageSaveRequest);

  return customAxiosInstance<ApiResponseWidgetCustomImageResponse>(
    {
      url: `/api/v8/dashboards/widgets/custom-images`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: widgetCustomImageSaveRequest,
      signal,
    },
    options,
  );
};

export const getPostV8DashboardsWidgetsCustomImagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsCustomImages>>,
    TError,
    { data: BodyType<WidgetCustomImageSaveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsCustomImages>>,
  TError,
  { data: BodyType<WidgetCustomImageSaveRequest> },
  TContext
> => {
  const mutationKey = ['postV8DashboardsWidgetsCustomImages'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8DashboardsWidgetsCustomImages>>,
    { data: BodyType<WidgetCustomImageSaveRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8DashboardsWidgetsCustomImages(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8DashboardsWidgetsCustomImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsCustomImages>>
>;
export type PostV8DashboardsWidgetsCustomImagesMutationBody =
  BodyType<WidgetCustomImageSaveRequest>;
export type PostV8DashboardsWidgetsCustomImagesMutationError = ErrorType<unknown>;

/**
 * @summary 이미지 저장
 */
export const usePostV8DashboardsWidgetsCustomImages = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8DashboardsWidgetsCustomImages>>,
      TError,
      { data: BodyType<WidgetCustomImageSaveRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8DashboardsWidgetsCustomImages>>,
  TError,
  { data: BodyType<WidgetCustomImageSaveRequest> },
  TContext
> => {
  const mutationOptions = getPostV8DashboardsWidgetsCustomImagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 이미지 조회
 */
export const getV8DashboardsWidgetsCustomImagesByImageId = (
  imageId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  imageId = unref(imageId);

  return customAxiosInstance<ApiResponseWidgetCustomImageResponse>(
    { url: `/api/v8/dashboards/widgets/custom-images/${imageId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8DashboardsWidgetsCustomImagesByImageIdQueryKey = (
  imageId?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'dashboards', 'widgets', 'custom-images', imageId] as const;
};

export const getGetV8DashboardsWidgetsCustomImagesByImageIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImagesByImageId>>,
  TError = ErrorType<unknown>,
>(
  imageId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImagesByImageId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DashboardsWidgetsCustomImagesByImageIdQueryKey(imageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImagesByImageId>>
  > = ({ signal }) => getV8DashboardsWidgetsCustomImagesByImageId(imageId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(imageId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImagesByImageId>>,
    TError,
    TData
  >;
};

export type GetV8DashboardsWidgetsCustomImagesByImageIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImagesByImageId>>
>;
export type GetV8DashboardsWidgetsCustomImagesByImageIdQueryError = ErrorType<unknown>;

/**
 * @summary 이미지 조회
 */

export function useGetV8DashboardsWidgetsCustomImagesByImageId<
  TData = Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImagesByImageId>>,
  TError = ErrorType<unknown>,
>(
  imageId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8DashboardsWidgetsCustomImagesByImageId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DashboardsWidgetsCustomImagesByImageIdQueryOptions(imageId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
